import { localize } from "utils/localizer";

const i18n = {
    accept: {
        en: "Accept",
        de: "Annehmen",
    },
    actions: {
        en: "Actions",
        de: "Aktionen",
    },
    ageGroups: {
        en: {
            kids: "Kids (< 18)",
            youngAdults: "Young Adults (18 - 26)",
            adults: "Adults (27 - 60)",
            seniors: "Seniors (> 60)",
            unknownAge: "Unknown Age",
            disabled: "Persons with visible disabilities",
        },
        de: {
            kids: "Kids (< 18)",
            youngAdults: "Junge Erwachsene (18 - 26)",
            adults: "Erwachsene (27 - 60)",
            seniors: "Senioren (> 60)",
            unknownAge: "Unbekanntes Alter",
            disabled: "Personen mit sichtbaren Beeinträchtigungen",
        },
    },
    aggregated: {
        en: "Aggregated",
        de: "Aggregiert",
    },
    all: {
        en: "All",
        de: "Alle",
    },
    allowComments: {
        en: "Allow comments",
        de: "Kommentare erlauben",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    apply: {
        en: "Apply",
        de: "Anwenden",
    },
    audienceGroup: {
        en: "Audience group",
        de: "Zielgruppe",
    },
    averageTimeWatchedSeconds: {
        en: "Average streaming duration",
        de: "Durchschnittliche Stream-Dauer",
    },
    bookings: {
        en: "Bookings",
        de: "Buchungen",
    },
    bookingsFrom: {
        en: "Bookings from",
        de: "Buchungen ab",
    },
    bookingQuery: {
        en: "Booking query",
        de: "Buchungssuche",
    },
    bookingDetails: {
        en: "Booking Details",
        de: "Buchungsdetails",
    },
    bookingStatus: {
        en: {
            cancelled: "Cancelled",
            pending: "Pending",
            final: "Final",
        },
        de: {
            cancelled: "Abgesagt",
            pending: "Ausstehend",
            final: "Bestätigt",
        },
    },
    bookingsTo: {
        en: "Bookings to",
        de: "Buchungen bis",
    },
    bookingType: {
        en: "Booking type",
        de: "Buchungstyp",
    },
    bookingTypes: {
        en: {
            blocking: "Blocking",
            meetup: "Meetup",
            standard: "Booking",
            training: "Event",
        },
        de: {
            blocking: "Sperrung",
            meetup: "Treffen",
            standard: "Buchung",
            training: "Event",
        },
    },
    by: {
        en: "by",
        de: "durch",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    cancellationReason: {
        en: "Cancellation reason",
        de: "Absagegrund",
    },
    checkIn: {
        en: "Check-in",
        de: "Check-in",
    },
    checkInStatus: {
        en: {
            "check-in-required": "Required",
            "not-required": "Not required",
            "checked-in": "Checked-in",
            "check-in-open": "Open",
            "check-in-missed": "Missed",
        },
        de: {
            "check-in-required": "Erforderlich",
            "not-required": "Nicht erforderlich",
            "checked-in": "Eingecheckt",
            "check-in-open": "Geöffnet",
            "check-in-missed": "Verpasst",
        },
    },
    checkInType3rdParty: {
        en: "By third party",
        de: "Durch Dritten",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    connectionShares30s: {
        en: "Connections still active after 30s",
        de: "Verbindungen noch aktiv nach 30s",
    },
    connectionShares5min: {
        en: "Connections still active after 5min",
        de: "Verbindungen noch aktiv nach 5min",
    },
    content: {
        en: "Content",
        de: "Inhalt",
    },
    court: {
        en: "Court",
        de: "Platz",
    },
    create: {
        en: "Create",
        de: "Erstellen",
    },
    createStory: {
        en: "Create Story",
        de: "Story erstellen",
    },
    creator: {
        en: "Creator",
        de: "Ersteller",
    },
    date: {
        en: "Date",
        de: "Datum",
    },
    decline: {
        en: "Decline",
        de: "Ablehnen",
    },
    details: {
        en: "Details",
        de: "Details",
    },
    edit: {
        en: "Edit",
        de: "Bearbeiten",
    },
    editBooking: {
        en: "Edit Booking",
        de: "Buchung bearbeiten",
    },
    endDate: {
        en: "End date",
        de: "Endzeit",
    },
    export: {
        en: "Export",
        de: "Exportieren",
    },
    exportOwnerOnly: {
        en: "Export can be used by owner only",
        de: "Exportfunktion nur für Eigentümer verfügbar",
    },
    filter: {
        en: "Filter",
        de: "Filtern",
    },
    firstName: {
        en: "First Name",
        de: "Vorname",
    },
    genders: {
        en: {
            m: "Male",
            f: "Female",
            d: "Diverse",
            u: "Unknown",
        },
        de: {
            m: "Männlich",
            f: "Weiblich",
            d: "Divers",
            u: "Unbekannt",
        },
    },
    general: {
        en: "General",
        de: "Allgemeines",
    },
    insertEmoji: {
        en: "Insert Emoji",
        de: "Emoji einfügen",
    },
    insertLink: {
        en: "Insert Link",
        de: "Link einfügen",
    },
    insertMedia: {
        en: "Insert Media",
        de: "Medien einfügen",
    },
    invitation: {
        en: "Invitation",
        de: "Einladung",
    },
    invitationStatus: {
        en: {
            accepted: "Accepted",
            declined: "Declined",
            pending: "Pending",
            "request-declined": "Request declined",
            "requested-to-join": "Requested",
        },
        de: {
            accepted: "Angenommen",
            declined: "Abgelehnt",
            pending: "Ausstehend",
            "request-declined": "Anfrage abgelehnt",
            "requested-to-join": "Angefragt",
        },
    },
    invite: {
        en: "Invite",
        de: "Einladen",
    },
    invitePlayers: {
        en: "Invite players",
        de: "Spieler einladen",
    },
    lastEdited: {
        en: "Last edited",
        de: "Letzte Änderung",
    },
    lastName: {
        en: "Last Name",
        de: "Nachname",
    },
    link: {
        en: "Link",
        de: "Link",
    },
    manageParticipants: {
        en: "Manage participants",
        de: "Teilnehmer verwalten",
    },
    never: {
        en: "Never",
        de: "Nie",
    },
    notAValidUrl: {
        en: "Not a valid URL (has to start with https://)",
        de: "Keine gültige URL (muss mit https:// beginnen)",
    },
    numConnectionStarts: {
        en: "Number of connection starts",
        de: "Anzahl Verbindungs-Starts",
    },
    numManualForms: {
        en: "Number of manual forms",
        de: "Anzahl manuell ausgefüllte Formulare",
    },
    numMaxViewers: {
        en: "Maximum concurrent viewers",
        de: "Maximale Zuschauer gleichzeitig",
    },
    numPlaybackStarts: {
        en: "Number of playback views",
        de: "Aufzeichnung Views",
    },
    numPrefilledForms: {
        en: "Number of prefilled forms",
        de: "Anzahl autom. ausgefüllte Formulare",
    },
    numUniqueViewers: {
        en: "Number of unique viewers",
        de: "Anzahl verschiedener Zuschauer",
    },
    ok: {
        en: "Ok",
        de: "Ok",
    },
    participantQuery: {
        en: "Participant query",
        de: "Teilnehmersuche",
    },
    participantRole: {
        en: "Participant role",
        de: "Mitspielerrolle",
    },
    participantRoles: {
        en: {
            coach: "Coach",
            standard: "Standard",
        },
        de: {
            coach: "Coach",
            standard: "Standard",
        },
    },
    participants: {
        en: "Participants",
        de: "Teilnehmer",
    },
    participantsPerAgeGroup: {
        en: "Participants per age group",
        de: "Teilnehmer pro Altersgruppe",
    },
    pastedImage: {
        en: "Pasted Image",
        de: "Bild aus Zwischenablage",
    },
    payment: {
        en: "Payment",
        de: "Zahlung",
    },
    paymentInfo: {
        en: "Payment info",
        de: "Zahlungsinformationen",
    },
    postAs: {
        en: "Post as",
        de: "Posten als",
    },
    postIn: {
        en: "Post in",
        de: "Posten in",
    },
    reactions: {
        en: "Reactions",
        de: "Reaktionen",
    },
    relHumidity: {
        en: "Rel. Humidity (%)",
        de: "Rel. Luftfeuchtigkeit (%)",
    },
    reset: {
        en: "Reset",
        de: "Zurücksetzen",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    single: {
        en: "Single",
        de: "Einzeln",
    },
    sipAggregate: {
        en: "SIP Report",
        de: "SIP Auswertung",
    },
    sipAggregateLong: {
        en: "Sport im Park Report",
        de: "Sport im Park Auswertung",
    },
    sipForm: {
        en: "SIP Form",
        de: "SIP Formular",
    },
    sipFormLong: {
        en: "Sport im Park Form",
        de: "Sport im Park Formular",
    },
    startDate: {
        en: "Start date",
        de: "Startzeit",
    },
    status: {
        en: "Status",
        de: "Status",
    },
    storyCreatedSuccessfully: {
        en: "Story created successfully",
        de: "Story erfolgreich erstellt",
    },
    streamingStats: {
        en: "Streaming stats",
        de: "Stream-Statistiken",
    },
    temperature: {
        en: "Temperature (°C)",
        de: "Temperatur (°C)",
    },
    text: {
        en: "Text",
        de: "Text",
    },
    time: {
        en: "Time",
        de: "Zeit",
    },
    weatherConditions: {
        en: "Weather conditions",
        de: "Wetterbedingungen",
    },
    weatherConditionsList: {
        en: {
            sunny: "Sunny",
            cloudy: "Cloudy",
            veryCloudy: "Very cloudy",
            rainy: "Rainy",
            veryRainy: "Very rainy",
        },
        de: {
            sunny: "Sonnig",
            cloudy: "Leicht bewölkt",
            veryCloudy: "Stark bewölkt",
            rainy: "Leichter Regen",
            veryRainy: "Starker Regen",
        },
    },
    site: {
        en: "Site",
        de: "Standort",
    },
    audienceSize: {
        en: "Approximate audience size ",
        de: "Ungefähre Anzahl der Empfänger ",
    },
    confirm: {
        en: "Confirm",
        de: "Bestätigen",
    },
    siteConfirmMessage: {
        en: "Approximate number of recipients: ",
        de: "Ungefähre Anzahl der Empfänger: ",
    },
    alert: {
        en: "Notice",
        de: "Hinweis",
    },
};

export default localize(i18n);
